import { arrayToSelectOptions } from "util/select";

function getAgentVersionOptions(versions) {
  const { agent = [] } = versions;
  return arrayToSelectOptions(agent);
}

function getPlayerVersionOptions(versions) {
  const { player = [] } = versions;
  return arrayToSelectOptions(player);
}

export { getAgentVersionOptions, getPlayerVersionOptions };
